import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useMutateData } from "../../hooks/useMutateData";
import { useFetchData } from "../../hooks/useFetchData";
import DOMPurify from "dompurify";

const UpdateAccountDetails = ({ show, onHide, accountData }) => {
  const [newStatus, setNewStatus] = useState();
  const [account, setAccount] = useState();
  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    if (accountData) {
      setNewStatus(accountData);
      setAccount(accountData);
    }
  }, [accountData]);

  // Fetch account status
  const { data: accountStatuses } = useFetchData(
    ["account-status"],
    "accounts/statuses",
    true,
    user
  );

  // Onchange Handlers
  const handleOnChangeAccount = (e) => {
    const { name, value } = e.target;
    const sanitizedValue = DOMPurify.sanitize(value); // Sanitize input value
    setAccount({
      ...account,
      [name]: sanitizedValue,
    });
  };

  // update subscriber and account
  const { mutate: updateAccount } = useMutateData();
  const successMessage = "Account updated successfully";
  const updateAccountDetails = async () => {
    const url = "accounts";
    const { status } = newStatus;
    const accountData = {
      ...account,
      status,
    };
    await updateAccount({
      url: url,
      payload: accountData,
      queryKeyToInvalidate: ["fetch-account"],
      successMessage,
      method: "PUT",
      closeModal: onHide,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Sanitize all account data before submitting
      const sanitizedAccount = {};
      for (let key in account) {
        sanitizedAccount[key] = DOMPurify.sanitize(account[key]);
      }
      const sanitizedNewStatus = {
        ...newStatus,
        status: {
          ...newStatus.status,
          name: DOMPurify.sanitize(newStatus.status.name),
        },
      };
      await updateAccountDetails(sanitizedAccount, sanitizedNewStatus);
    } catch (error) {
      console.error("Error updating account:", error);
    }
  };

  return (
    <div>
      <Modal
        size='md'
        aria-labelledby='contained-modal-title-vcenter'
        centered
        show={show}
      >
        <Modal.Header closeButton onClick={onHide}>
          <h5>Edit Account Details</h5>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "#f0f0fa" }}>
          <Form onSubmit={handleSubmit}>
            <label className='ml-2'>Subscriber Id</label>
            <input
              className='form-control input-select mb-2'
              value={account?.id}
              disabled
            />
            <label className='ml-2'>Names</label>
            <input
              placeholder='Names'
              className='form-control input-select mb-2'
              name='accountName'
              value={account?.accountName}
              onChange={handleOnChangeAccount}
            />
            <label className='ml-2'>Phone number</label>
            <input
              placeholder='Phone number'
              className='form-control input-select mb-2'
              value={account?.accountNumber}
              name='phoneNumber'
              readOnly
            />
            <select
              className='form-control input-select'
              name='status'
              onChange={(e) => {
                const { value, options } = e.target;
                const label = options[options.selectedIndex].label;
                const sanitizedLabel = DOMPurify.sanitize(label); // Sanitize option label
                setNewStatus({
                  ...newStatus,
                  status: {
                    id: value,
                    name: sanitizedLabel,
                  },
                });
              }}
              required
            >
              <option value={account?.status?.id}>
                {account?.status?.name}
              </option>
              {accountStatuses?.map((status) => (
                <option key={status?.id} value={status?.id}>
                  {status?.name}
                </option>
              ))}
            </select>
            <div className='d-flex justify-content-center'>
              <Button className='custom-btn-color' type='submit'>
                Save Changes
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default UpdateAccountDetails;
